<kendo-dialog *ngIf="active" (close)="closeForm()" [width]="460" [height]="600">
    <kendo-dialog-titlebar>
      {{ isNew ? 'Add new service key' : 'Edit service key' }}
    </kendo-dialog-titlebar>

    <div class="form-group">
        <label class="control-label">Service:&nbsp;</label>
        <label class="control-label">{{service ? service.Code : ''}}</label>
    </div>
    <div class="form-group" [hidden]="scope === 1">
        <label class="control-label">Environment:&nbsp;</label>
        <label class="control-label">{{environment ? environment.Code : ''}}</label>
    </div>    
    <div class="form-group" [hidden]="scope != 3">
        <label class="control-label">Tenant:&nbsp;</label>
        <label class="control-label">{{tenant ? tenant.Code : ''}}</label>
    </div>       
    <form novalidate [formGroup]="editForm">
            <div class="form-group" [hidden]="scope != 1">
                <label for="IsLocked" class="control-label">Locked&nbsp;</label>
                <input type="checkbox" kendoCheckBox formControlName="IsLocked" />
            </div>
            <div class="form-group">
                <label for="CategoryId" class="control-label">Category</label>
                <kendo-dropdownlist
                    [ngClass]="itemClass"
                    [formControl]="editForm.controls.CategoryId"
                    [valuePrimitive]="true"
                    [data]="categories"
                    [textField]="'Name'"
                    [valueField]="'Id'">
                </kendo-dropdownlist>
            </div>                    
            <div class="form-group">
                <label for="Name" class="control-label">Name</label>
                <input type="text" kendoTextBox class="k-textbox modal-row-element" formControlName="Name" />           
                <div class="k-tooltip-validation tooltip-stacked"
                    *ngIf="editForm.controls.Name.invalid && !editForm.controls.Name.untouched">
                    <div *ngIf="editForm.controls.Name.hasError('required')">
                        <span class="k-icon k-i-warning"></span>
                        Name is required
                    </div>
                    <div *ngIf="editForm.controls.Name.hasError('minlength')">
                        <span class="k-icon k-i-warning"></span>
                        Name must be at least 3 characters
                    </div>
                    <div *ngIf="editForm.controls.Name.hasError('maxlength')">
                        <span class="k-icon k-i-warning"></span>
                        Name must not exceed 50 characters
                    </div>
                    <div *ngIf="editForm.controls.Name.hasError('pattern')">
                        <span class="k-icon k-i-warning"></span>
                        Name must only contain letters, numbers, spaces, colons, underscores, dashes, periods
                    </div> 
                    <div *ngIf="editForm.controls.Name.hasError('unique')">
                        <span class="k-icon k-i-warning"></span>
                        Name is already taken by another configuration key within this service and category
                    </div>                
                </div>
            </div>
            <div class="form-group">
                <label for="IsSecret" class="control-label">Secret&nbsp;</label>
                <input type="checkbox" kendoCheckBox formControlName="IsSecret" />
            </div>            
            <div class="form-group">
                <label for="Value" class="control-label">Service Value</label>
                <input type="text" kendoTextBox class="k-textbox modal-row-element" formControlName="Value" />
                <div class="k-tooltip k-tooltip-validation tooltip-stacked"
                    *ngIf="editForm.controls.Value.invalid && !editForm.controls.Value.untouched">
                    <div *ngIf="editForm.controls.Value.hasError('maxlength')">
                        <span class="k-icon k-i-warning"></span>
                        Value must not exceed 12,000 characters
                    </div>             
                </div>
            </div>
            <div class="form-group" [hidden]="scope === 3">
                <label for="AllowEnvironmentOverride" class="control-label">Allow Environment Override&nbsp;</label>
                <input type="checkbox" kendoCheckBox formControlName="AllowEnvironmentOverride" />
            </div>
            <div class="form-group" [hidden]="scope === 1">
                <label for="EnvironmentValue" class="control-label">Environment Value</label>
                <input type="text" kendoTextBox class="k-textbox modal-row-element" formControlName="EnvironmentValue" />
                <div class="k-tooltip k-tooltip-validation tooltip-stacked"
                    *ngIf="editForm.controls.EnvironmentValue.invalid && !editForm.controls.EnvironmentValue.untouched">
                    <div *ngIf="editForm.controls.EnvironmentValue.hasError('maxlength')">
                        <span class="k-icon k-i-warning"></span>
                        Environment Value must not exceed 12,000 characters
                    </div>             
                </div>
            </div>            
            <div class="form-group" [hidden]="scope === 2">
                <label for="AllowTenantOverride" class="control-label">Allow Tenant Override&nbsp;</label>
                <input type="checkbox" kendoCheckBox formControlName="AllowTenantOverride" />
            </div> 
            <div class="form-group" [hidden]="scope != 3">
                <label for="TenantValue" class="control-label">Tenant Value</label>
                <input type="text" kendoTextBox class="k-textbox modal-row-element" formControlName="TenantValue" />
                <div class="k-tooltip k-tooltip-validation tooltip-stacked"
                    *ngIf="editForm.controls.TenantValue.invalid && !editForm.controls.TenantValue.untouched">
                    <div *ngIf="editForm.controls.TenantValue.hasError('maxlength')">
                        <span class="k-icon k-i-warning"></span>
                        Tenant Value must not exceed 12,000 characters
                    </div>             
                </div>
            </div>                        
            <div class="form-group" [hidden]="scope != 1">
                <label for="Description" class="control-label">Description</label>
                <textarea kendoTextArea cols="60" rows="2" class="modal-row-element" formControlName="Description"></textarea>
                <div class="k-tooltip k-tooltip-validation"
                    *ngIf="editForm.controls.Description.invalid && !editForm.controls.Description.untouched">
                    <div class="tooltip-stacked" *ngIf="editForm.controls.Description.hasError('maxlength')">
                        <span class="k-icon k-i-warning"></span>
                        Description must not exceed 200 characters
                    </div>
                    <div class="tooltip-stacked" *ngIf="editForm.controls.Description.hasError('pattern')">
                        <span class="k-icon k-i-warning"></span>
                        Description must only contain letters, numbers, spaces, colons, semicolons, underscores, dashes, periods, returns
                    </div>              
                </div>
            </div>         
    </form>
    
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">Cancel</button>
        <button class="k-button k-primary" 
            [disabled]="(scope === 2 && !allowEnvironmentOverride) || (scope === 3 && !allowTenantOverride) || !editForm.valid" 
            (click)="onSave($event)">
            Save
        </button>
    </kendo-dialog-actions>
</kendo-dialog>
`

